const inflectionExceptions: { [name: string]: string } = {
  category: 'categories'
}

export function inflect(count: number, word: string): string {
  if (count == 1) return word
  return inflectionExceptions[word] || word + 's'
}

function caseBy(string: string, char: string): string {
  return string
    .replace(/[-_]/g, char)
    .replace(/^[A-Z]/g, (letter) => letter.toLowerCase()) // lower case first char
    .replace(/[A-Z]/g, (letter) => `${char}${letter.toLowerCase()}`) // add chars after all
}

export function snakeCase(string: string): string {
  return caseBy(string, '_')
}

export function dasherize(string: string): string {
  return caseBy(string, '-')
}

export function titleify(string: string): string {
  var index = 0
  return caseBy(string, ' ').replace(/\b[A-Za-z]/g, (letter) => {
    index++
    return index == 1 ? letter.toUpperCase() : letter.toLowerCase()
  })
}

export function camelize(str: string): string {
  return str
    .split(/[_-]/g)
    .map((part, idx) => (idx == 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)))
    .join('')
}

export function humanJoin(words: string[], separator: string = 'and'): string {
  if (words.length == 0) {
    return ''
  } else if (words.length == 1) {
    return words[0]
  } else if (words.length == 2) {
    return `${words[0]} ${separator} ${words[1]}`
  } else {
    return `${words.slice(0, -1).join(', ')}, ${separator} ${words[words.length - 1]}`
  }
}
